export class InvoiceCommissionBreakout {
    id: string;
    commissionAmount: number;
    premium?: number;
    subPercent?: number;
    override: boolean;
    changedDate: Date;
    enteredDate: Date;
}
